// ** Third Party Components
import styled, { css } from "styled-components";

// ####################################################

export const MessageContainerWrapper = styled.div`
	display: flex;
	margin-top: 0.25rem;
	word-break: break-word;
	max-width: 80%;

	${({ isRightSide }) =>
		isRightSide &&
		css`
			margin-left: auto;
		`}

	${({ isSeparator }) =>
		isSeparator &&
		css`
			margin-top: 0.5rem;
		`}
`;

// ####################################################
